import { useSelector } from 'react-redux';
import { getLanguageCode, stripHtmlTags } from '@triumph/shared';
import {
  getBikeModel,
  getFinanceOption,
  getFormData,
  getSelectedDealer,
  getSelectedMake,
  getSelectedModel,
  getSelectedServicePack,
  getSelectedWarrantyPack,
  getOfferBanner,
} from 'src/redux/app/selectors';

export default () => {
  const bikeModel = useSelector(getBikeModel);
  const selectedFinanceOption = useSelector(getFinanceOption);
  const formData = useSelector(getFormData);
  const selectedDealer = useSelector(getSelectedDealer);
  const make = useSelector(getSelectedMake);
  const model = useSelector(getSelectedModel);
  const servicePack = useSelector(getSelectedServicePack);
  const warrantyPack = useSelector(getSelectedWarrantyPack);
  const offerBanner = useSelector(getOfferBanner);

  return {
    countryMarket: () => getLanguageCode(),
    configuratorBikeName: () => stripHtmlTags(bikeModel?.name),
    configuratorBikeID: () => bikeModel?.id,
    configuratorBikeYear: () => bikeModel?.year,
    configuratorFinalPrice: () => bikeModel?.price,
    configuratorGenre: () => bikeModel?.genre || '',
    configuratorProductCode: () => bikeModel?.productCode,
    dealerName: () => selectedDealer?.Title || '',
    financeProduct: () => selectedFinanceOption?.panelTitle || '',
    tradeIn: () => (formData.make ? `${make.name} - ${model.name}` : ''),
    ctaText: () => '',
    sectionEdit: () => '',
    configuratorExtraName: () => warrantyPack?.title || servicePack?.title,
    configuratorExtraPrice: () => warrantyPack?.price || servicePack?.price,
    offerPresent: () => !!offerBanner,
    offerName: () => offerBanner?.title,
  };
};
